
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class TicketService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/tickets', query);
    }
    listByFilter(query?:any) {
        return this.get('/tickets-filter', query);
    }
    count(query?: any) {
        return this.get('/count-tickets', query);
    }

    create(body: any) {
        return this.post('/ticket', body);
    }

    find(id) {
        return this.get('/ticket/' + id);
    }

    update(id, body) {
        return this.put('/ticket/' + id, body);
    }

    updateMany(query, body) {
        return this.put('/update-tickets', {
            where: query,
            data: body
        })
    }

    status(query?: any) {
        return this.get('/status')
    }

    updateStatusCalling(body){
        return this.put('/call-status',body);
    }

    findByCall(call_id?: any) {
        return this.get('/find-ticket-mongo/', { call_id: call_id });
    }

    findByQuery(query) {
        return this.get('/find-ticket/', query);
    }

    facebookSyncTicket(body?: any) {
        return this.post('/facebook-ticket', body);
    }

    ticketsByListStatus(statusList, options?: any) {
        let observableBatch = [];
        statusList.forEach((e) => {
            let query = [
                {
                    key: 'status',
                    condition: '=',
                    value: e.id
                }
            ];
            if(options) {
                query.push(options);
            }
            observableBatch.push(this.get('/tickets', {
                filters: JSON.stringify(query)
            }));
        });

        return Observable.forkJoin(observableBatch);
    }

    merge(data) {
        return this.post('/ticket/merge/', data);
    }

    mergeMany(data) {
        return this.post('/ticket/mergeMany/', data);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Ticket.service.ts